export const API_ENDPOINT_DEV = 'http://localhost:8000/api';
// export const API_ENDPOINT_DEV = 'https://gbnewsbackend.salmonsea-e5a92576.northeurope.azurecontainerapps.io/api';
export const API_ENDPOINT_PROD = 'https://gbnewsbackend.mittenai.com/api';
// export const API_ENDPOINT_PROD = 'https://kuwait-banking-backend-858423531240.us-central1.run.app/api';
export const API_ENDPOINT = process.env.NODE_ENV === 'production' ? API_ENDPOINT_PROD : API_ENDPOINT_DEV;